package com.partejar.app.core.preferences

import com.partejar.app.core.ui.theme.ThemeMode
import com.russhwolf.settings.Settings

interface ThemePreferenceRepository {
    fun getThemeMode(): ThemeMode
    fun setThemeMode(themeMode: ThemeMode)
}

class SettingsThemePreferenceRepository(
    private val settings: Settings
) : ThemePreferenceRepository {

    override fun getThemeMode(): ThemeMode =
        ThemeMode.fromStoredValue(settings.getStringOrNull(THEME_MODE_KEY))

    override fun setThemeMode(themeMode: ThemeMode) {
        settings.putString(THEME_MODE_KEY, themeMode.name)
    }

    private companion object {
        const val THEME_MODE_KEY = "appearance.theme_mode"
    }
}
